module.exports = __webpack_public_path__ + "img/编组@2x.966c584d.png";